export const LETTER_FONTS = [
  { id: "Playwrite US Modern", label: "Playwrite US Modern" },
  { id: "Times New Roman", label: "Times New Roman" },
  { id: "Poppins", label: "Poppins" },
];

export const LETTER_TEXT_STYLES = [
  { id: "title", label: "Titre", size: "28" },
  { id: "subtitle", label: "Sous-titre", size: "20" },
  { id: "text", label: "Texte", size: "16" },
];

export const DEFAULT_LETTER_PREFERENCES = {
  fontFamily: "Playwrite US Modern",
  textStyle: "text",
};

const GENERIC_FONT_FAMILIES = new Set([
  "cursive",
  "serif",
  "sans-serif",
  "monospace",
  "fantasy",
  "system-ui",
  "ui-serif",
  "ui-sans-serif",
  "ui-monospace",
  "emoji",
  "math",
  "fangsong",
  "inherit",
  "initial",
  "unset",
]);

/** Strip quotes / fallbacks and normalize for comparison. */
export function normalizeFontFamilyName(value = "") {
  return String(value)
    .replace(/['"]/g, "")
    .split(",")
    .map((part) => part.trim())
    .find((part) => part && !GENERIC_FONT_FAMILIES.has(part.toLowerCase()))
    || "";
}

function collapseFontKey(value = "") {
  return normalizeFontFamilyName(value).toLowerCase().replace(/\s+/g, " ");
}

/**
 * Map a computed / inline font-family string to a LETTER_FONTS id.
 * Uses exact then fuzzy includes matching so browser quoting / fallbacks still resolve.
 */
export function matchLetterFont(rawFontFamily, fallbackId = null) {
  const key = collapseFontKey(rawFontFamily);
  if (!key) {
    return (
      LETTER_FONTS.find((f) => f.id === fallbackId)?.id ||
      fallbackId ||
      null
    );
  }

  const exact = LETTER_FONTS.find((font) => collapseFontKey(font.id) === key);
  if (exact) return exact.id;

  const fuzzy = LETTER_FONTS.find((font) => {
    const id = collapseFontKey(font.id);
    return key.includes(id) || id.includes(key);
  });
  if (fuzzy) return fuzzy.id;

  return (
    LETTER_FONTS.find((f) => f.id === fallbackId)?.id ||
    fallbackId ||
    null
  );
}

export function getTextStyleSize(textStyleId) {
  return (
    LETTER_TEXT_STYLES.find((s) => s.id === textStyleId)?.size ||
    LETTER_TEXT_STYLES.find((s) => s.id === "text")?.size ||
    "16"
  );
}

export function buildEditorFontStyle(fontFamily, textStyleId) {
  const size = getTextStyleSize(textStyleId);
  return {
    font: `${size}px "${fontFamily}", cursive`,
    padding: "32px",
    lineHeight: "1.7",
  };
}

export function preferencesFromLetter(letter, letterId) {
  const fromApi = {
    fontFamily: letter?.fontFamily || letter?.preferences?.fontFamily,
    textStyle: letter?.textStyle || letter?.preferences?.textStyle,
  };

  if (fromApi.fontFamily && fromApi.textStyle) {
    return {
      fontFamily: matchLetterFont(fromApi.fontFamily, DEFAULT_LETTER_PREFERENCES.fontFamily),
      textStyle: fromApi.textStyle,
    };
  }

  try {
    const saved = localStorage.getItem(`bbr_letter_prefs_${letterId}`);
    if (saved) {
      const parsed = JSON.parse(saved);
      return {
        fontFamily: matchLetterFont(
          parsed.fontFamily,
          DEFAULT_LETTER_PREFERENCES.fontFamily
        ),
        textStyle: parsed.textStyle || DEFAULT_LETTER_PREFERENCES.textStyle,
      };
    }
  } catch {
    // ignore
  }

  return { ...DEFAULT_LETTER_PREFERENCES };
}

export function savePreferencesLocally(letterId, preferences) {
  localStorage.setItem(
    `bbr_letter_prefs_${letterId}`,
    JSON.stringify(preferences)
  );
}
